var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgInviteIcon = function SvgInviteIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#7E8A9A",
    fillRule: "evenodd",
    d: "M12.363 8.396c-.328-1.623-1.887-2.668-3.482-2.334a2.848 2.848 0 0 0-.668.239A2.97 2.97 0 0 0 6.95 7.478a3.002 3.002 0 0 0-.36.918c-.082.4-.082.811-.001 1.21.067.331.196.637.361.918a2.97 2.97 0 0 0 1.264 1.178c.212.103.433.19.668.239a2.89 2.89 0 0 0 1.19 0c1.594-.335 2.62-1.921 2.292-3.545Zm-.784 4.463h-4.21c-.113 0-.222.016-.33.03-.03.005-.061.01-.092.013C5.265 13.11 4 14.563 4 16.288v.857a.85.85 0 0 0 .842.857h9.263c.224 0 .438-.09.596-.25a.863.863 0 0 0 .246-.607v-.857c0-1.894-1.508-3.429-3.368-3.429ZM17 9a1 1 0 1 1 2 0v2h2a1 1 0 1 1 0 2h-2v2a1 1 0 1 1-2 0v-2h-2a1 1 0 1 1 0-2h2V9Z",
    clipRule: "evenodd"
  })));
};
export default SvgInviteIcon;